import React, { useContext } from 'react';
import styles from './AcfFilteredListItem.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { FilteredListContext } from 'wp-blocks/AcfFilteredList/AcfFilteredList';
import formatUrlPath from '@/helpers/formatUrlPath';

let cx = className.bind(styles);

export default function AcfFilteredListItem(props) {
	const { attributes, filteredListItem, innerBlocks } = props;
	const className = attributes.className?.split(' ') || [];

	const selectedSlugs = useContext(FilteredListContext);

  const slug = formatUrlPath(filteredListItem.filterSlug);

	return (
		<>
			{(selectedSlugs.includes(slug) || selectedSlugs.includes('all') || selectedSlugs.length === 0) ? (
				<div className={cx(['ns_filtered-list-item', 'filtered-list-item', ...className])} data-slug={slug}>
					{React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}
				</div>
			) : null}
		</>
	);
}

AcfFilteredListItem.fragments = {
	key: `AcfFilteredListItemFragment`,
	entry: gql`
		fragment AcfFilteredListItemFragment on AcfFilteredListItem {
			attributes {
				className
			}
			filteredListItem {
				filterSlug
			}
		}
	`,
};

AcfFilteredListItem.config = {
	name: 'AcfFilteredListItem',
};
AcfFilteredListItem.displayName = 'AcfFilteredListItem';
